export default __webpack_public_path__ + "static/media/Luvia_fuerte_a_torrencial.5bf4d0f5.svg";